// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/editor.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetEditorRequest, GetEditorResponse, ListEditorsRequest, ListEditorsResponse, ResolveEditorURLRequest, ResolveEditorURLResponse } from "./editor_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.EditorService
 */
export const EditorService = {
  typeName: "gitpod.v1.EditorService",
  methods: {
    /**
     * Lists all available code editors.
     *
     * Use this method to:
     * - View supported editors
     * - Get editor capabilities
     * - Browse editor options
     * - Check editor availability
     *
     * ### Examples
     *
     * - List editors:
     *
     *   Shows all available editors with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.EditorService.ListEditors
     */
    listEditors: {
      name: "ListEditors",
      I: ListEditorsRequest,
      O: ListEditorsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific editor.
     *
     * Use this method to:
     * - View editor information
     * - Get editor configuration
     *
     * ### Examples
     *
     * - Get editor details:
     *
     *   Retrieves information about a specific editor.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EditorService.GetEditor
     */
    getEditor: {
      name: "GetEditor",
      I: GetEditorRequest,
      O: GetEditorResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Resolves the URL for accessing an editor in a specific environment.
     *
     * Use this method to:
     * - Get editor access URLs
     * - Launch editors for environments
     * - Set up editor connections
     * - Configure editor access
     *
     * ### Examples
     *
     * - Resolve editor URL:
     *
     *   Gets the URL for accessing an editor in an environment.
     *
     *   ```yaml
     *   editorId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.EditorService.ResolveEditorURL
     */
    resolveEditorURL: {
      name: "ResolveEditorURL",
      I: ResolveEditorURLRequest,
      O: ResolveEditorURLResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

